import React from 'react';
import Steps, { Step } from 'rc-steps';
import Logo from './Logo';

export default class RegistrationStepIndicator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        if (!window.VULOG_CONFIG) {
            return null;
        }
        let step = this.props.currentPosition;
        if (step === -1) {
            return <Logo />;
        }

        if ([1, 2].indexOf(step)) {
            return <Logo />;
        }
        if (!window.VULOG_CONFIG) {
            return null;
        }

        if (!window.VULOG_CONFIG.ENABLE_STEPS) {
            return <Logo />;
        }
        const titles = window.VULOG_CONFIG['STEPS_TITLE'];
        const steps = window.VULOG_CONFIG['STEPS'];
        let labels = titles.map(t => window.VULOG_TRANSLATE(t));

        let currentStepTitle = null;
        steps.forEach(s => {
            if (s.screen === step) {
                currentStepTitle = s.title;
            }
        });

        if (!currentStepTitle) {
            currentStepTitle = step;
        }

        let currentStepNumber = null;
        titles.forEach((t, index) => {
            if (t === currentStepTitle) {
                currentStepNumber = index;
            }
        });

        if (currentStepNumber === null) {
            return null;
        }
        //rewrite steps

        return [
            <Logo />,
            <Steps current={currentStepNumber} style={{ marginBottom: 15 }}>
                {labels.map(label => {
                    return <Step title={label} />;
                })}
            </Steps>,
        ];
    }
}
